import React from 'react'
import { useNavigate } from 'react-router'
import {
  IconPaint,
  // IconWorld, IconBrush, IconMail,
  IconTemplate,
} from '@tabler/icons-react'
import Typography from '../../../atoms/Typography'
import { ROUTES } from 'src/types/routes'

interface WhiteLabelMessageProps {
  onMinimize?: () => void
}

const WhiteLabelMessage: React.FC<WhiteLabelMessageProps> = ({ onMinimize }) => {
  const navigate = useNavigate()

  const handleUpgrade = () => {
    navigate(ROUTES.SUBS)
    // Minimize Copa window after navigating
    if (onMinimize) {
      onMinimize()
    }
  }

  return (
    <div className="flex w-full flex-col gap-[10px] p-3">
      {/* Message Title */}
      <Typography variant="sm-medium" className="whitespace-pre-wrap leading-[20px] text-[#EBF4F1]">
        Great! Let&apos;s make Atlas your own with complete with labeling capabilities, by presenting a fully branded
        experience to your clients and team.
      </Typography>

      {/* Upgrade Card */}
      <div className="flex w-full flex-col gap-4 rounded-[8px] border border-[#656E75] bg-[#1B1C1E] px-6 py-4">
        {/* Feature Items */}
        <div className="flex flex-col gap-4">
          {/* Custom branding & logo */}
          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconPaint className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Custom branding & logo
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                Upload your logo and customize colors to match your brand
              </Typography>
            </div>
          </div>

          {/* <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconWorld className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Custom domain support
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                Host your workspace on your own domain (e.g.,maps.yourcompany.com)
              </Typography>
            </div>
          </div>

          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconBrush className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Remove Atlas branding
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                Hide all "Powered by Atlas" references and presents as your own
              </Typography>
            </div>
          </div>

          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconMail className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Custom email notifications
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                Send brand emails from your domaing with your logo
              </Typography>
            </div>
          </div> */}
        </div>
      </div>

      {/* White Labeling Info Section */}
      <div className="flex w-full flex-col gap-4 rounded-[8px] border border-[#329175] bg-[rgba(50,145,117,0.2)] p-4">
        <div className="flex w-full items-start gap-2">
          <div className="flex h-6 w-6 shrink-0 items-center justify-center">
            <IconTemplate className="h-6 w-6 text-[#329175]" stroke={1.5} />
          </div>
          <div className="flex flex-1 flex-col">
            <Typography variant="sm-medium" className="leading-[20px] text-[#CDD1D4]">
              White labeling is available on our Enterprise plan.
            </Typography>
            <Typography variant="sm-medium" className="leading-[20px] text-[#CDD1D4]">
              Perfect for agencies, consultants, and businesses serving clients.
            </Typography>
          </div>
        </div>

        {/* Upgrade Plan Button */}
        <button
          onClick={handleUpgrade}
          className="flex h-12 w-full items-center justify-center gap-3 rounded-[100px] bg-[#329175] px-8 py-4 transition-all duration-200 hover:brightness-110"
        >
          <IconTemplate className="h-5 w-5 text-[#F5F6F6]" stroke={1.5} />
          <Typography variant="base-medium" className="leading-[24px] text-[#F5F6F6]">
            Upgrade Plan
          </Typography>
        </button>
      </div>
    </div>
  )
}

export default WhiteLabelMessage
